import React from 'react';
import { PageLoading } from 'components/atoms/loading';
import { ErrorBoundary } from 'components/molecules/error-boundary';
import { CallbackErrorPage } from './error';
import { LoginCallback } from './login-callback';

export const ImplicitCallback = () => {
  return (
    <ErrorBoundary>
      <LoginCallback
        loadingElement={<PageLoading />}
        errorComponent={CallbackErrorPage}
      />
    </ErrorBoundary>
  );
};
